import { RelocationType } from "@/gql/graphql";
import { useSettingsSupplier } from "@/app/Suppliers/Utils/useSettingsSupplier";
import {
  EditableRowsProvider,
  EditableSettingRow,
  SettingRowsCard,
} from "@/app/Settings/Settings/Components/EditableSettingRow";
import { useGqlMutation } from "@/lib/GraphQLCodegen/fetcher";
import { updateSupplierMutation } from "@/app/Suppliers/GraphQL/supplierMutations";
import { TextAreaInput } from "@/lib/Components/Form/Inputs/TextAreaInput";
import { RichTextInput } from "@/lib/Components/Form/Inputs/RichTextInput";
import { NoSupplierEmptyState } from "@/app/Settings/Settings/Components/NoSupplierEmptyState";
import { stripHtml } from "@/lib/Utils/string";
import { TermsAndConditionsSettingsCard } from "@/app/Settings/Settings/Components/TermsAndConditionsSettingsCard";

export function SettingsGapRentalsScreen() {
  const { supplier } = useSettingsSupplier();
  const { mutateAsync } = useGqlMutation(updateSupplierMutation);

  if (!supplier) {
    return <NoSupplierEmptyState />;
  }

  return (
    <EditableRowsProvider>
      <div className="space-y-8">
        <SettingRowsCard
          title="Cancellation policy"
          description="Shown on your gap rental pages. Applies to gap rentals only — your relocation cancellation policy is not used here."
        >
          <EditableSettingRow
            label="Cancellation policy"
            value={supplier.gap_rentals_cancellation_policy}
            editClassName="max-w-2xl"
            initialValues={{
              gap_rentals_cancellation_policy:
                supplier.gap_rentals_cancellation_policy,
            }}
            onSave={(values) => mutateAsync({ id: supplier.id, input: values })}
          >
            <TextAreaInput
              name="gap_rentals_cancellation_policy"
              label="Cancellation policy"
              className="col-span-full"
              optionalLabel
              textAreaProps={{ rows: 6 }}
            />
          </EditableSettingRow>
        </SettingRowsCard>

        <SettingRowsCard
          title="Standard inclusions"
          description="Shown on your gap rental pages. If left empty, no inclusions are shown — your standard relocation inclusions are not used."
        >
          <EditableSettingRow
            label="Standard inclusions"
            value={
              supplier.gap_rentals_standard_inclusions
                ? stripHtml(supplier.gap_rentals_standard_inclusions)
                : undefined
            }
            editClassName="max-w-2xl"
            initialValues={{
              gap_rentals_standard_inclusions:
                supplier.gap_rentals_standard_inclusions,
            }}
            onSave={(values) => mutateAsync({ id: supplier.id, input: values })}
          >
            <RichTextInput
              name="gap_rentals_standard_inclusions"
              label="Standard inclusions"
              className="col-span-full"
              optionalLabel
            />
          </EditableSettingRow>
        </SettingRowsCard>

        <TermsAndConditionsSettingsCard
          supplierId={supplier.id}
          relocationType={RelocationType.GapRental}
          title="Gap Rental Terms & Conditions"
          description="Upload a PDF of the terms shown on your gap rental pages. If left empty, no terms are shown — your standard rental terms are not used."
          showLicenseRequirements={false}
        />
      </div>
    </EditableRowsProvider>
  );
}
